import styled from "styled-components";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
export const Wrapper = styled.div`
	padding: 100px 120px 0 100px;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: stretch;
	text-align: center;

	h1 {
		padding-bottom: 25px;
	}

	@media screen and (max-width: 780px) {
		padding: 100px 30px 0 30px;
	} ;
`;

export const ContentWrapper = styled.div`
	width: 100%;
	height: 100%;
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
	grid-template-rows: repeat(auto-fill, 1fr);
	justify-items: stretch;
	align-items: center;
	gap: 50px;
	@media screen and (max-width: 780px) {
		width: 100%;
		grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));

		grid-template-rows: repeat(auto, 1fr);
		gap: 5px;
		row-gap: 25px;
		column-gap: 15px;
	} ;
`;

export const Content = styled.div`
	background-color: ${({ menu }) => menu.menuColor};
	width: 100%;
	height: 100%;
	min-width: 270px;
	min-height: 460px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	border-radius: 5px;
	box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.33);
	-webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.33);
	-moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.33);
	@media screen and (max-width: 780px) {
		width: 100%;
		height: 100%;
		min-width: 150px;
		min-height: 350px;
	} ;
`;
export const ContentImg = styled(LazyLoadImage)`
	height: 90%;
	width: 75%;
	margin-top: 25px;
	object-fit: contain;

	img {
		height: 100%;
	}

	@media screen and (max-width: 780px) {
		margin-top: 0;
	}
`;

export const ContentWord = styled.div`
	width: 100%;
	height: 40%;
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	align-items: stretch;
	text-align: center;

	.menu-name {
		font-size: var(--fontBig);
		font-weight: 600;
		padding-bottom: 5px;
	}

	.menu-price {
		font-size: 2rem;
		font-weight: 700;
	}

	.icehot {
		font-size: 20px;
		padding: 5px 0;
	}

	.addition {
		font-weight: 600;
		font-size: var(--fontSmall);
		list-style-type: none;
		text-align: center;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: space-between;
		gap: 5px;
	}
	@media screen and (max-width: 780px) {
		justify-content: stretch;
		height: 25%;

		.menu-name {
			font-size: 1rem;
			font-weight: 500;
			padding: 0 5px;
		}
		.menu-price {
			font-size: var(--fontMed);
			font-weight: 700;
			padding: 5px 0;
		}
		.icehot {
			font-size: 1rem;
			padding: 0;
		}
		.addition {
			font-size: 10px;
			margin: 5px 5px;
			columns: 2 auto;
		}
	}
`;
